
import React from 'react';

interface PipDisplayProps {
  videoRef: React.RefObject<HTMLVideoElement>;
  currentEmotion: string;
  currentEmoji: string;
  emotionPercentage: string | null;
  isRecording: boolean;
}

const PipDisplay: React.FC<PipDisplayProps> = ({
  videoRef,
  currentEmotion,
  currentEmoji,
  emotionPercentage,
  isRecording
}) => {
  return (
    <div className="absolute top-5 right-5 z-10 rounded-lg overflow-hidden shadow-lg">
      <div className="relative">
        <video 
          ref={videoRef}
          className="w-40 h-30 object-cover rounded-lg"
          autoPlay
          playsInline
          muted
        />

        {/* Always show Emotion display at the top of the PIP feed - removed conditional rendering */}
        <div className="absolute top-0 left-0 right-0 bg-black/70 p-2 text-xs text-white flex items-center justify-between">
          <div className="flex items-center">
            {currentEmoji && (
              <img 
                src={currentEmoji} 
                className="w-5 h-5 mr-1" 
                alt={currentEmotion || 'Emotion'}
                crossOrigin="anonymous"
              />
            )}
            <span className="truncate capitalize font-semibold">
              {currentEmotion || 'Detecting...'}
            </span>
          </div>
          {emotionPercentage && (
            <span className="ml-1 text-xs opacity-75">
              {emotionPercentage}
            </span>
          )}
        </div>

        {/* Recording indicator */}
        {isRecording && (
          <div className="absolute top-1 right-1 flex items-center">
            <div className="w-3 h-3 rounded-full bg-red-600 animate-pulse mr-1"></div>
            <span className="text-xs text-white font-bold bg-black/50 px-1">REC</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PipDisplay;
